import Vue from 'vue';

const state = () => ({
  selecaoCooperado: null,
  selecaoClienteRural: null,
  selecaoCpfCnpj: null,
  mesAno: null,
  email: '',
  selecaoMunicipio: null,
  selecaoProjeto: null,
  selecaoSafra: null,

  // Persistir na API opcional
  cooperadoLkp: [],
  clienteRuralLkp: [],
  selecaoMunicipioLkp: [],
  selecaoProjetoLkp: [],
  selecaoSafraLkp: []
});

const mutations = {
  SET_FILTRO_CLIENTES_RURAIS(state, filtro) {
    Object.keys(filtro).forEach(key => {
      if (key in state) {
        Vue.set(state, key, filtro[key]);
      }
    });
  },

  SET_FILTRO_CAMPO(state, { campo, valor }) {
    if (campo in state) {
      Vue.set(state, campo, valor);
    }
  },

  SET_OPCOES_FILTRO(state, { campo, valor }) {
    if (campo in state) {
      Vue.set(state, campo, valor);
    }
  },

  RESET_FILTROS_CLIENTES_RURAIS(state) {
    const camposParaLimpar = [
      'email',
      'mesAno',
      'selecaoSafra',
      'selecaoCpfCnpj',
      'selecaoProjeto',
      'selecaoCooperado',
      'selecaoMunicipio',
      'selecaoClienteRural',
    ];

    camposParaLimpar.forEach(key => {
      Vue.set(state, key, key === 'email' ? '' : null);
    });
  }
};

const getters = {
  filtroClientesRurais: (state) => ({
    selecaoCooperado: state.selecaoCooperado,
    selecaoClienteRural: state.selecaoClienteRural,
    selecaoCpfCnpj: state.selecaoCpfCnpj,
    mesAno: state.mesAno,
    email: state.email,
    selecaoMunicipio: state.selecaoMunicipio,
    selecaoProjeto: state.selecaoProjeto,
    selecaoSafra: state.selecaoSafra
  }),

  hasFiltrosAtivos: (state) => {
    const campos = [
      'email',
      'mesAno',
      'selecaoSafra',
      'selecaoCpfCnpj',
      'selecaoProjeto',
      'selecaoCooperado',
      'selecaoMunicipio',
      'selecaoClienteRural',
    ];

    return campos.some(campo => {
      const value = state[campo];
      return value !== null && value !== undefined && value !== '';
    });
  }
};

const actions = {
  setFiltroClientesRurais({ commit }, filtro) {
    commit('SET_FILTRO_CLIENTES_RURAIS', filtro);
  },

  setFiltroCampo({ commit }, payload) {
    commit('SET_FILTRO_CAMPO', payload);
  },

  setOpcoesFiltro({ commit }, payload) {
    commit('SET_OPCOES_FILTRO', payload);
  },

  limparFiltrosClientesRurais({ commit }) {
    commit('RESET_FILTROS_CLIENTES_RURAIS');
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
